import classnames from 'classnames';
import { kebabCase } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
const EmployeesRow = props => {
  const {
    index,
    data,
    id,
    data: {
      firstName,
      lastName,
      username
    },
    onClick: propsOnClick
  } = props;
  const classes = classnames(`t-er-${index}`, `t-er-last-first-${kebabCase(data.lastName)}-${kebabCase(data.firstName)}`);
  return /*#__PURE__*/React.createElement("tr", {
    className: classes,
    onClick: () => propsOnClick(id)
  }, /*#__PURE__*/React.createElement("td", {
    className: "t-er-name"
  }, `${lastName}, ${firstName}`), /*#__PURE__*/React.createElement("td", {
    className: `t-er-username t-er-username-${kebabCase(username)}`
  }, username));
};
EmployeesRow.propTypes = {
  index: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    lastName: PropTypes.string,
    firstName: PropTypes.string,
    username: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
};
export default EmployeesRow;